import React, { Component } from 'react';
import * as API from './api.js';
import './style.css';
import Loader from './icons/loader.svg';
import Search from "./Icon/Search.png";
import dateFormat from 'dateformat';
import { Link, Redirect } from 'react-router-dom';
import { SortComponent } from './ReusableComponents/SortComponent.js';
import LoaderComponent from './ReusableComponents/LoaderComponent.js';
import TableView from './ReusableComponents/TableView/TableView.js';

export default class AdminUsersEmailLogs extends Component {
    state = {
        user: {},
        tableState: {
            pageNumber: 1,
            pageSize: 15,
        },
        loading: true,
        allEmailLogs: [],
        totalCount: 0,
        tableLoading: true,
        key: undefined
    }

    getAllEmailLogs = () => {
        this.setState({ tableLoading: true })
        API.getAllEmailLogs(this.state.key, this.state.tableState).then((res) => {
            this.setState({
                allEmailLogs: res.allEmailLogs || [],
                totalCount: res.allEmailLogs?.[0]?.total_count || 0,
                loading: false,
                tableLoading: false
            })

        })
    }

    componentWillMount() {
        document.title = "Users - Admin";
        if (this.props.location.state) {
            let { user } = this.props.location.state;
            this.setState((state) => ({
                ...state,
                user
            }), () => {
                this.getAllEmailLogs()
            })
        } else {
            API.getUserType().then(([blah, type, user]) => {
                this.setState((state) => ({
                    ...state,
                    user
                }), () => {
                    this.getAllEmailLogs()
                })
            }, (e) => {
                window.location.replace("/login");
            })
        }
    }
    search(key) {
        this.setState({
            tableState: {
                ...this.state.tableState,
                pageNumber: 1,
            },
            tableLoading: true,
            key,
        }, () => this.getAllEmailLogs());
    }

    render() {
        return <div className="wrapper">
            <div className="right-content-new">
                <div className="top-bar-new" style={{ display: "flex" }}><div className="top-bar-text-new">Email Logs</div></div>
                {this.state.loading ? <LoaderComponent />
                    : <div className="main-content-new">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 20px' }}>
                            <div className="services-content-title">{`Email Logs`}
                                <span className='services-content-title'>({this.state.totalCount})</span>
                            </div>
                            <div className="add-user-form-text-wrapper">
                                <img src={Search} style={{ height: "20px", width: "20px", position: 'relative', left: '25px' }} />
                                <input type="text" className="add-user-form-text" placeholder="Search by email & subject" style={{ height: '30px !important', width: "300px", paddingLeft: '28px' }}
                                    onChange={(event) => {
                                        this.search(event.target.value)
                                    }} />
                            </div>
                        </div>
                        <div style={{ height: 'calc(100% - 150px)' }}>
                            <TableView
                                // headingLeft={"Email Logs"}
                                isLoading={this.state.tableLoading}
                                pageNumber={this.state.tableState?.pageNumber || 1}
                                onStateChange={(state) => {
                                    this.setState({ tableState: state }, () => { this.getAllEmailLogs() })
                                }}
                                onClickRow={(emailLog) => { }}
                                data={this.state.allEmailLogs.length != 0 ? this.state.allEmailLogs : []}
                                columns={this.state.allEmailLogs.length != 0 ? [
                                    { Header: "Email", accessor: "send_to", width: '35%', },
                                    { Header: "Subject", accessor: "subject", width: '40%' },
                                    { Header: "Status", accessor: "status_data", width: '10%' },
                                    { Header: "Date & Time", accessor: "date_time", isDate: true, width: '15%' },
                                ] : []}
                                count={this.state.totalCount || 0}
                            />
                        </div>
                    </div>}
            </div>
        </div >
    }
}